import TransitionDialog from 'components/TransitionDialog';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import React from 'react';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import CongratulationsImage from 'public/images/congratulations.svg';
import styles from 'styles/components/Congratulations.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: '#f5f0ff',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      height: 'auto',
      width: '60%',
      borderRadius: 10,
    },

    [theme.breakpoints.up('md')]: {
      width: '40%',
      height: 'auto',
    },

    [theme.breakpoints.up('xl')]: {
      width: '20%',
    },
  },

  paperFullWidth: {
    margin: '0 auto',

    [theme.breakpoints.up('sm')]: {
      borderRadius: 10,
    },
  },
}));

const SendDeliverableDialog = () => {
  const open = useModalOpen('Send Deliverable');

  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    dispatch(closeModal('Send Deliverable'));
    dispatch(closeModal('Milestone'));
    dispatch(closeModal('New Milestone'));
  };

  const fullWidth = { minWidth: 160, width: '100%' };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      desktopDirection="up"
      direction="up"
      noCloseIcon
    >
      <div className={styles.congratulations}>
        <div className={styles.title}>
          <CongratulationsImage />

          <h3>BOOM!</h3>

          <h2>
            Your deliverable has been sent to the client. They have 48 hours to approve. Once
            approved, your funds will be deposited into your GigSocial wallet.
          </h2>
        </div>

        <div className={styles.buttons}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            style={fullWidth}
            fullWidth
          >
            Ok
          </Button>
        </div>
      </div>
    </TransitionDialog>
  );
};

export default SendDeliverableDialog;
